<template>
	<v-row no-gutters style="height: calc(100vh - 60px)">
		<v-col class="py-0 px-0" cols="12" md="4">
			<PatientDetailsCard
				:edit="showEdit"
				v-if="$store.state.detailedUserState"
				:video="video"
				@openMedicationEditDialog="openMedicationEditDialog"
				@openViewAllMedicationsDialog="openViewAllMedicationsDialog"
				:style="{ height: $vuetify.breakpoint.smAndDown ? '70vh' : 'calc(100vh - 60px)' }" />
			<v-container v-else fluid class="fill-height flex-column justify-center align-center">
				<v-progress-circular indeterminate :size="50" width="4" color="primary"> </v-progress-circular>
				<p class="mt-5">{{ $t('loading') }}...</p>
			</v-container>
		</v-col>
		<v-col cols="12" md="8" class="pa-0" style="overflow: hidden" ref="drawerContainer" v-resize="resizeDrawer">
			<CCMRecords v-if="selectedRpmOrCcm === 'CCM' && ccmChecked" />
			<div v-else-if="selectedRpmOrCcm === 'RPM' && rpmChecked" style="height: 100%">
				<v-navigation-drawer
					v-if="selectedVitalsDrawer || selectedWellnessDrawer"
					right
					absolute
					:width="drawerContainer"
					class="z-index5">
					<WellnessDrawer
						style="height: calc(100vh - 60px)"
						v-if="selectedWellnessDrawer"
						:selectedSurvey="selectedWellnessDrawer"
						@close="closeWellness"
						:wellnessType="selectedWellnessDrawer" />
					<VitalsDrawer
						v-if="selectedVitalsDrawer"
						ref="VitalsDrawer"
						@close="closeDrawer"
						:vitalsType="selectedVitalsDrawer"
						:unitSystem="getUnitSystem" />
				</v-navigation-drawer>
				<v-row v-else dense class="ma-0" style="width: 100%">
					<v-tabs
						:ripple="false"
						class="d-flex justify-center align-center background-white overview"
						:value="activeTab"
						icons-and-text
						v-model="tabs">
						<v-tab @click="change('overview')" :ripple="false" class="Overview_tab">
							{{ $t('overview') }}
						</v-tab>
						<v-tab @click="change('monitoringPlan')" :ripple="false" class="Overview_tab">
							{{ $t('monitoring-plans') }}
						</v-tab>
						<v-tab @click="change('notes')" :ripple="false" class="Overview_tab">
							{{ $t('notes') }}
						</v-tab>
						<v-tab @click="change('labs')" :ripple="false" class="Overview_tab" v-if="false">
							{{ $t('labs') }}
						</v-tab>
					</v-tabs>
					<Overview
						v-if="$store.state.detailedUserState && activeTab === 'overview'"
						ref="OverviewCards"
						:key="rerender"
						@toggledrawer="toggleDrawer"
						@toggledrawer2="toggleDrawer2" />
				</v-row>
				<template v-if="activeTab === 'overview'">
					<v-row
						v-if="!detailedUser?.userData.isCcmEnabled"
						class="px-2 mt-n1 mb-0 pb-1"
						style="height: calc(100% - 233px)"
						dense>
						<v-col cols="12" md="6">
							<OverviewNotifications />
						</v-col>
						<v-col cols="12" md="6">
							<Chat
								v-if="detailedUser"
								:userToChat="detailedUser.userData"
								:video="video"
								:key="rerender"
								:filter="filterChanged"
								class="chat-class" />
						</v-col>
					</v-row>
				</template>
				<v-card v-if="activeTab === 'monitoringPlan'">
					<MonitoringPlans :computedPatientId="computedPatientId" />
				</v-card>
				<v-card elevation="0" v-if="activeTab === 'notes'" class="h-88">
					<Notes :detailedUser="detailedUser" :notes="notesFromRepo" class="hp-100" />
				</v-card>
				<v-card elevation="0" v-if="activeTab === 'labs'">
					<Labs />
				</v-card>
			</div>

			<div v-else>
				<v-navigation-drawer
					v-if="selectedVitalsDrawer || selectedWellnessDrawer"
					right
					absolute
					:width="drawerContainer"
					class="z-index5">
					<WellnessDrawer
						v-if="selectedWellnessDrawer"
						:selectedSurvey="selectedWellnessDrawer"
						@close="closeWellness"
						:wellnessType="selectedWellnessDrawer" />
					<VitalsDrawer
						v-if="selectedVitalsDrawer"
						ref="VitalsDrawer"
						@close="closeDrawer"
						:vitalsType="selectedVitalsDrawer"
						:unitSystem="getUnitSystem" />
				</v-navigation-drawer>
				<v-row v-else dense class="ma-0" style="width: 100%">
					<v-tabs
						:ripple="false"
						class="d-flex justify-center align-center background-white overview"
						:value="activeTab"
						icons-and-text
						v-model="tabs">
						<v-tab @click="change('overview')" :ripple="false" class="Overview_tab">
							{{ $t('overview') }}
						</v-tab>
						<v-tab @click="change('monitoringPlan')" :ripple="false" class="Overview_tab">
							{{ $t('monitoring-plans') }}
						</v-tab>
						<v-tab @click="change('notes')" :ripple="false" class="Overview_tab">
							{{ $t('notes') }}
						</v-tab>
						<v-tab @click="change('labs')" :ripple="false" class="Overview_tab" v-if="false">
							{{ $t('labs') }}
						</v-tab>
					</v-tabs>
					<Overview
						v-if="$store.state.detailedUserState && activeTab === 'overview'"
						ref="OverviewCards"
						:key="rerender"
						@toggledrawer="toggleDrawer"
						@toggledrawer2="toggleDrawer2" />
				</v-row>
				<template v-if="activeTab === 'overview'">
					<v-row v-if="!detailedUser?.userData.isCcmEnabled" class="px-2 mt-n1 mb-0 pb-1" dense>
						<v-col cols="6">
							<OverviewNotifications />
						</v-col>
						<v-col cols="6">
							<Chat
								v-if="detailedUser"
								:userToChat="detailedUser.userData"
								:video="video"
								:key="rerender"
								:filter="filterChanged"
								class="chat-class" />
						</v-col>
					</v-row>
				</template>
				<v-card v-if="activeTab === 'monitoringPlan'">
					<MonitoringPlans :computedPatientId="computedPatientId" />
				</v-card>
				<v-card elevation="0" v-if="activeTab === 'notes'">
					<Notes :detailedUser="detailedUser" :notes="notesFromRepo" />
				</v-card>
				<v-card elevation="0" v-if="activeTab === 'labs'">
					<Labs />
				</v-card>
			</div>

			<MedicationEditDialog
				v-if="showMedicationEditDialog"
				:show-dialog="showMedicationEditDialog"
				:prescription="editingMedication"
				@exitMedicationEditDialog="exitMedicationEditDialog" />
			<ViewAllMedicationsDialog
				v-if="showViewAllMedicationsDialog"
				:show-dialog="showViewAllMedicationsDialog"
				@exitViewAllMedicationsDialog="showViewAllMedicationsDialog = false" />
		</v-col>
	</v-row>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import PatientDetailsCard from './PatientDetailsCard.vue';
import OverviewNotifications from '@/views/Client/components/OverviewNotifications.vue';
import Chat from './Chat/Chat.vue';
import Overview from '@/views/Client/components/Overview.vue';
import MonitoringPlans from '@/views/Client/components/MonitoringPlans.vue';
import Notes from '@/views/Client/components/Notes.vue';
import WellnessDrawer from '@/views/DrawerDialogs/WellnessDrawer.vue';
import MedicationEditDialog from '@/views/dialogs/MedicationEditDialog.vue';
import ViewAllMedicationsDialog from '../../dialogs/ViewAllMedicationsDialog.vue';
import VitalsDrawer from '@/views/DrawerDialogs/VitalsDrawer';
import Labs from '@/views/Client/components/Labs.vue';
import CCMRecords from '@/views/Client/components/ChronicCareManagement/CCMRecords.vue';

export default {
	components: {
		Labs,
		PatientDetailsCard,
		Overview,
		Notes,
		MonitoringPlans,
		WellnessDrawer,
		VitalsDrawer,
		OverviewNotifications,
		Chat,
		MedicationEditDialog,
		ViewAllMedicationsDialog,
		CCMRecords,
	},
	props: ['video', 'filterChanged'],
	data () {
		return {
			drawerContainer: 0,
			ccmChecked: false,
			rpmChecked: false,
			showEdit: true,
			filterChange: false,
			userLoading: true,
			dialog: true,
			selectedVitalsDrawer: false,
			selectedWellnessDrawer: false,
			selectedSurvey: null,
			notificationsLoading: true,
			toggle: null,
			rerender: 1,
			filterChat: 'LAST7',
			tabs: null,
			activeTab: 'overview',
			editingMedication: null,
			activeTime: 0,
			showMedicationEditDialog: false,
			showViewAllMedicationsDialog: false,
		};
	},
	async mounted () {
		await this.getUserById();
		await this.getMyNotifications();
		this.$store.commit('SET_DETAILED_USER_STATE', true);

		this.checkPageToSetVisible();
	},
	computed: {
		...mapState({
			detailedUser: (state) => state.users.detailedUser,
			startTimeTrackingInfo: (state) => state.timetracking.startTimeTrackingInfo,
			notesFromRepo: (state) => state.appointments.notes,
			notifications: (state) => state.notifications.allNotifications,
			notificationsWithUser: (state) => state.notifications.notificationsWithUser,
			filterCase: (state) => state.authentication.filterCase,
			authUser: (state) => state.authentication.userData,
			selectedRpmOrCcm: (state) => state.authentication.selectedRpmOrCcm,
		}),
		...mapGetters({
			userSettings: 'authentication/getUserSettings',
			roleName: 'authentication/getRole',
		}),

		userTimeZone () {
			return this.detailedUser?.userData.userTimezone;
		},
		computedPatientId () {
			return this.detailedUser.medicalTeamData[0].patientId;
		},
		getUnitSystem () {
			var units = { concentration: '', unitSystem: '' };
			units.unitSystem = this.userSettings.Units.toLowerCase();
			units.concentration = this.userSettings.Concentration.toLowerCase();
			return units;
		},
	},
	watch: {
		filterChat () {
			this.filterChange = true;
		},
		detailedUser () {
			this.checkPageToSetVisible();
		},
		selectedRpmOrCcm () {
			this.checkPageToSetVisible();
		},
	},
	methods: {
		...mapActions({
			storeCCMRecordsByPatientId: 'ccmRecords/storeMinimalCCMRecordsByPatientId',
			getSelectedCCMRecordId: 'ccmRecords/getSelectedCCMRecordId',
		}),
		checkPageToSetVisible () {
			this.rpmChecked = this.detailedUser.userData.isRpmEnabled;
			this.checkCCM();
		},

		async checkCCM () {
			if (this.detailedUser.userData.isCcmEnabled) {
				this.$store.commit('ccmRecords/SET_CCM_RECORD', null);
				this.$store.commit('ccmRecords/SET_CMM_RECORDS_BY_PATIENT_ID', []);
				await this.storeCCMRecordsByPatientId(this.detailedUser.userData.id);
			}
			this.ccmChecked = this.detailedUser.userData.isCcmEnabled;
		},

		resizeDrawer () {
			this.drawerContainer = this.$refs.drawerContainer.clientWidth;
		},

		toggleDrawer (vitals) {
			this.selectedVitalsDrawer = vitals;
		},
		toggleDrawer2 (wellness) {
			this.selectedWellnessDrawer = wellness;
		},
		closeDrawer () {
			this.selectedVitalsDrawer = false;
		},
		closeWellness () {
			this.selectedWellnessDrawer = false;
		},
		change (tab) {
			this.activeTab = tab;
		},
		async getUserById () {
			if (this.$store.state.users.detailedUser?.userData?.id === parseInt(this.$route.params.id)) {
				this.userLoading = false;
				return;
			}
			this.userLoading = true;
			await this.$store.dispatch('users/getUserById', this.$route.params.id).then(() => {
				this.userLoading = false;
			});
		},
		async getMyNotifications () {
			const object = {
				filterCase: this.$cookies.get('datafilter'),
				patientId: parseInt(this.$route.params.id),
			};
			this.notificationsLoading = true;
			await this.$store.dispatch('notifications/getNotificationsWithPatient', object).then(() => {
				this.readedNotication = this.notificationsWithUser.length;
			});
			this.notificationsLoading = false;
		},
		openMedicationEditDialog (medication) {
			this.editingMedication = medication;
			this.showMedicationEditDialog = true;
		},
		openViewAllMedicationsDialog () {
			this.showViewAllMedicationsDialog = true;
		},
		exitMedicationEditDialog () {
			this.showMedicationEditDialog = false;
		},
	},
};
</script>
